import { Clock, MapPin, Home, Scale, Star } from "lucide-react";
import Reveal from "./Reveal";
import { OFFICE } from "../../data/content";

const STATS = [
  { icon: Home,  value: "8+",  label: "Propiedades" },
  { icon: Scale, value: "3",   label: "Abogados" },
  { icon: Star,  value: "15+", label: "Años de experiencia" },
];

const Hero = () => {
  return (
    <section id="inicio" className="rr-hero" data-testid="hero-section">
      {/* Animated background orbs */}
      <span className="hero-orb hero-orb-1" aria-hidden="true" />
      <span className="hero-orb hero-orb-2" aria-hidden="true" />
      <span className="hero-orb hero-orb-3" aria-hidden="true" />

      <div className="rr-container" style={{ textAlign: "center", position: "relative", zIndex: 1 }}>
        <Reveal>
          <span className="section-eyebrow hero-eyebrow">
            Técpan de Galeana, Guerrero
          </span>
          <h1 className="rr-hero-title font-display" data-testid="hero-title">
            Inmobiliaria y Despacho Jurídico
            <br />
            <span className="accent-orange">Rendón</span> <span className="accent-navy">Ramos</span>
          </h1>
          <p className="rr-hero-sub">
            Compra, venta y renta de propiedades con total certeza legal, y un equipo de abogados
            especializados listos para defender sus intereses.
          </p>
          <div className="rr-hero-pills">
            <span className="hero-pill" data-testid="hero-hours-pill">
              <Clock size={15} /> {OFFICE.hours}
            </span>
            <span className="hero-pill" data-testid="hero-location-pill">
              <MapPin size={15} /> Centro, Técpan de Galeana
            </span>
          </div>

          {/* Stats strip */}
          <div className="hero-stats" data-testid="hero-stats">
            {STATS.map(({ icon: Icon, value, label }) => (
              <div key={label} className="hero-stat">
                <Icon size={22} strokeWidth={1.6} className="hero-stat-icon" />
                <strong className="hero-stat-value">{value}</strong>
                <span className="hero-stat-label">{label}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.14}>
          <div className="brand-cards">
            <div className="brand-card inmo" data-testid="brand-card-inmobiliaria">
              <div className="logo-badge">
                <img src="/assets/logo-inmobiliaria.jpg" alt="Inmobiliaria Rendón Ramos" />
              </div>
              <h3 className="font-display">Inmobiliaria</h3>
              <p>
                Casas, terrenos y propiedades en venta y renta. Cada operación respaldada
                jurídicamente de principio a fin.
              </p>
              <a href="#inmobiliaria" className="btn btn-gold" data-testid="hero-cta-inmobiliaria">
                Ver propiedades
              </a>
            </div>
            <div className="brand-card legal" data-testid="brand-card-despacho">
              <div className="logo-badge">
                <img src="/assets/logo-despacho.jpg" alt="Despacho Jurídico Rendón Ramos" />
              </div>
              <h3 className="font-display">Despacho Jurídico</h3>
              <p>
                Asesoría y representación en materia civil, familiar, laboral, notarial y
                registral con abogados de amplia trayectoria.
              </p>
              <a href="#despacho" className="btn btn-navy" data-testid="hero-cta-despacho">
                Servicios jurídicos
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
